import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import API_SEARCH from '../../../api/apiSearch';
import IconDeleteBlue from '../../../assets/icons/IconDeleteBlue';
import IconDetailBlue from '../../../assets/icons/IconDetailBlue';
import IconEditBlue from '../../../assets/icons/IconEditBlue';
import IconAddBlue from '../../../assets/icons/IconAddBlue';
import SearchbarMenu from '../../../components/Searchbar/SearchbarMenu';
import ActionType from '../../../redux/reducer/globalActionType';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_ROLE_DELETE,
    MASTER_DATA_ROLE_INSERT,
    MASTER_DATA_ROLE_UPDATE,
    MASTER_DATA_ROLE_VIEW
} from '../../../constants/menuPermissionConstant';
import Alert from '../../../components/Alert/Alert';
import TableNexcare from '../../../components/Table/TableNexcare';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';

class Role extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            columnsRole: [
                {
                    title: "ID Peran",
                    dataIndex: "role_id",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Deskripsi Peran",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Waktu Dibuat",
                    dataIndex: "created_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Waktu Diubah",
                    dataIndex: "updated_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Diubah Oleh",
                    dataIndex: "modified_by",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer mr-5" id="btnroledetail" onClick={() => this.handleDetailRole(data)}><IconDetailBlue /></span>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer mr-5" id="btnroleedit" onClick={() => this.handleEditRole(data)}><IconEditBlue /></span>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer" id="btnroledelete" onClick={() => this.handleConfirmDeleteRole(data)}><IconDeleteBlue /></span>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            data: [],
            filter: '',
            role: {},
            showSuccessAlert: false,
            showConfirmAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateRole = () => {
        API_MASTER_DATA.getInitiateRole(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListRole = () => {
        API_MASTER_DATA.getListRole(this.state.pagination.current, this.state.pagination.pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        data: getContent(res)
                    })
                }
            }).catch(err => {
                this.setState({ loading: false });
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getInitiateSearchRole = keyword => {
        API_SEARCH.getInitiateRole(keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchRole = keyword => {
        API_SEARCH.getListRole(this.state.pagination.current, this.state.pagination.pageSize, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        data: getContent(res)
                    });
                }
            }).catch(err => {
                this.setState({ loading: false });
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleSearch = async keyword => {
        await this.setState({
            loading: true,
            pagination: {
                ...this.state.pagination,
                current: 1
            },
            keyword
        });
        this.getInitiateSearchRole(keyword);
        this.getSearchRole(keyword);
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getListRole();
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getListRole();
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                loading: true,
                filter: sorter
            },
            () => {
                this.getListRole();
            }
        );
    }

    handleDetailRole = role => {
        this.props.history.push(`/master-data/role/detail/${role.id}`)
    }

    handleEditRole = role => {
        this.props.history.push(`/master-data/role/edit/${role.id}`)
    }

    handleConfirmDeleteRole = role => {
        this.setState({
            showConfirmAlert: true,
            role
        })
    }

    handleDeleteRole = () => {
        this.setState({ showConfirmAlert: false })

        const data = {
            updated_at: this.state.role.updated_at
        }

        API_MASTER_DATA.deleteDataRole(this.state.role.id, data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(() => {
                    this.setState({
                        showSuccessAlert: false,
                        pagination: {
                            ...this.state.pagination,
                            current: 1
                        }
                    })
                    this.getInitiateRole();
                    this.getListRole();
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateRole();
        this.getListRole();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_VIEW]} userPermission={this.props.userDetail.permissions}>
                <LoadingLoader show={this.state.loading} />
                <SearchbarMenu handleSearch={this.handleSearch} placeholder="Role ID" />
                <div className="w-full flex justify-between mb-5">
                    <div></div>
                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_INSERT]} userPermission={this.props.userDetail.permissions}>
                        <NavLink
                            to={ROUTER_CONSTANT.MASTER_DATA_ROLE_ADD}
                            className="rounded-full bg-white text-darkblue font-bold border-2 border-white px-3 py-1 flex items-center"
                            activeClassName="bg-blue-200 border-2 border-white"
                            id="btnaddrole"
                        >
                            <IconAddBlue />
                            <span className="ml-2">Tambah</span>
                        </NavLink>
                    </CheckPermissionComponent>
                </div>
                <div className="bg-white rounded-2xl">
                    <TableNexcare
                        column={this.state.columnsRole}
                        dataTable={this.state.data}
                        pagination={this.state.pagination}
                        onPage={this.handleSelectedPage}
                        onPageSize={this.handleSelectedPageSize}
                        onSorter={this.handleSorter}
                    />
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Menghapus Role!" />
                <Alert show={this.state.showConfirmAlert} icon="delete" button={true} title="Apakah Anda yakin menghapus peran ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleDeleteRole()} />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Role);